import React from "react";
import { Draggable } from "components/drag-and-drop";
import { Brikk } from "components/Brikk";
import { SeeMoreButton } from "components/form-elements/buttons/SeeMoreButton";
import { Image } from "components/media/Image";
import { SmartHouseLightIcon } from "assets/icons/brikks/SmartHouseLightIcon";
import brikkPreviewSrc from "./assets/scenarios-brikk-preview.png";

export const Scenarios = ({ position }) => {
  return (
    <>
      <Draggable position={position}>
        <Brikk disabled={true}>
          <Brikk.Header icon={<SmartHouseLightIcon />} heading="scenariosBrikk" />

          <Brikk.Content center>
            <Image src={brikkPreviewSrc} />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton disabled={true} brikkNameIntl="scenarios" />
          </Brikk.Button>
        </Brikk>
      </Draggable>
    </>
  );
};
